type OrderedReference = {
    code: string | number;
    display_order: number;
};

export function sortCodesByDisplayOrder(codes: string[], references: OrderedReference[]): string[] {
    const orderByCode = new Map<string, number>();

    for (const item of references) {
        const order = Number(item.display_order);
        if (Number.isFinite(order)) {
            orderByCode.set(String(item.code), order);
        }
    }

    return [...codes].sort((left, right) => {
        const orderLeft = orderByCode.get(left) ?? Number.POSITIVE_INFINITY;
        const orderRight = orderByCode.get(right) ?? Number.POSITIVE_INFINITY;
        if (orderLeft !== orderRight) {
            return orderLeft - orderRight;
        }

        return left.localeCompare(right);
    });
}
